import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { finalize, first } from 'rxjs/operators';
import { isNullOrUndefined, ToastService } from 'src/app/core';
import { CWApi, CWDocCombined, CWDocument, CWProfile, EmployeeDoc, EmployeeDocDelete, EmployeeProfile, EmployeeProfileApi, LookupField } from 'src/app/core/api.gen';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/core/common.service';
import { DialogService } from 'src/app/core/dialog.service';
import { DocumentUploadService } from 'src/app/core/document-upload.service';
import { LoaderService } from 'src/app/core/loader.service';
import { OpenFilePreviewService } from 'src/app/core/open-file-preview.service';
import { nullSafe } from 'src/app/utils';
import { Logger } from 'src/app/utils/Logger';
import { LookupTypeKeys } from '../lookup-type-keys';
import saveAs from 'file-saver';

@Component({
  selector: 'eos-cwfile-upload',
  templateUrl: './cwfile-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class CWFileUploadComponent implements OnInit {

  @Input() readonly = false;
  @Input() isEdit = false;
  @Input() cwProfile: CWProfile;
  @Input() candidateForm;
  @Input() showingFileUpload=false;
  @Output() GetDocumentEvent = new EventEmitter<CWDocCombined[]>();
  @Output() validDocuments = new EventEmitter<LookupField[]>();
  @Output() update = new EventEmitter<boolean>();
  @ViewChild('fileField') element: ElementRef;
  @ViewChild('fileControl') fileEle: ElementRef;
  @ViewChild('f') form: NgForm;
  readonly allowedMineTypes = [
    'application/pdf'
    , 'image/jpeg'
    , 'image/png'
    , 'application/msword'
    , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    , 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    , 'application/vnd.ms-excel'
  ];

  readonly MAX_FILE_SIZE: number = 10 * 1024 * 1024;
  readonly MIN_FILE_SIZE: number = 1 * 1024;
  fileDetails: any;
 
  uploadedCount: number;
  pendingAllCount: number;
  pendingCount: number;
  totalCount: number;
  allFiles: CWDocCombined[] = [];
  gridFiles: CWDocCombined[] = [];
  showSpinner = false;
  selectedTab: number;
  isMandatoryChecked: any;
  allDoc: boolean;
  uploadedDoc: boolean;
  pendingDoc: boolean;
  isSearch: boolean;
  selectedDocument: any;
  disableUpload: boolean;
  docName: string;
  lookupType: any;
  constructor( 
    private cwApi: CWApi,
    private common: CommonService,
    private dialog: DialogService,
    private openfilepreview: OpenFilePreviewService,
    private toast: ToastService,
    private authService: AuthService,
    private fileUploadService: DocumentUploadService,
    private loader: LoaderService,
    private activeRoute: ActivatedRoute) {
    this.fileDetails = new CWDocCombined();
    this.fileDetails.documentTypeId = null;
    this.fileDetails.documentNameId = null;
    }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    this.getCWProfileDocuments();
  }

  delete(fileDetails) {
    const docDeletReq = new CWDocument();
    docDeletReq.id = fileDetails.id;
    docDeletReq.modifiedById = this.authService.ActiveUser.employeeId;
    docDeletReq.cwProfileId = this.cwProfile.id;
    docDeletReq.fileGuiId = fileDetails.fileGuiId;  

    this.dialog.showConfirmationBox('Confirm delete',
      'Are you sure you want to delete this file?',
      () => {
        this.cwApi.deleteFile(docDeletReq).subscribe((resp) => {
          if (resp) {
            this.toast.success("Document deleted!");
          } else {
            this.toast.error("Document deletion failed!");
          }
          this.update.emit();
          this.getCWProfileDocuments();
        });
      });
  }
  isEditable(item) {  
    return true;
  }
  getCWProfileDocuments() {
    if(this.cwProfile && this.cwProfile.id>0 && this.showingFileUpload){//&& this.showingFileUpload
        this.allFiles = [];
        this.cwApi.getCWDocuments(this.cwProfile).subscribe(resp => {
        this.allFiles = resp;
        this.uploadedCount = this.allFiles.filter(x => x.isUploaded).length;
        this.pendingAllCount = this.allFiles.length - (this.allFiles.filter(x => x.isUploaded).length);
        this.pendingCount = (this.allFiles.filter(x => x.mandatoryType == 1).length) - (this.allFiles.filter(x => x.mandatoryType == 1 && x.isUploaded).length);
        this.totalCount = this.allFiles.length;
        this.gridFiles = this.allFiles;
        this.getfileGrid(1);
        this.GetDocumentEvent.emit(resp);
      });
    
    }
  }


  getfileGrid(type: number) {
      this.selectedTab = 1;
      this.gridFiles = this.isMandatoryChecked?this.allFiles.filter(x => x.mandatoryType == 1):this.allFiles;
      this.allDoc = true;
      this.uploadedDoc = false;
      this.pendingDoc = false;
      if (type == 2) {
        this.selectedTab = 2;
        this.gridFiles = this.isMandatoryChecked?this.allFiles.filter(x => x.mandatoryType == 1 && x.isUploaded):this.allFiles.filter(x => x.isUploaded);
        this.allDoc = false;
        this.uploadedDoc = true;
        this.pendingDoc = false;
      } else if (type == 3) {
        this.selectedTab = 3;
        this.gridFiles = this.isMandatoryChecked?this.allFiles.filter(x => x.mandatoryType == 1 && !x.isUploaded):this.allFiles.filter(x => !x.isUploaded);
        this.allDoc = false;
        this.uploadedDoc = false;
        this.pendingDoc = true;

      }
   

  }
  previewImageFile(token: string, details: EmployeeDoc) {
    this.dialog.showImagePreview(this.openfilepreview.constructPDFUrl(token, this.docName), this.docName);
    // window.open(this.openfilepreview.constructPDFUrl(token, this.docName), '_blank');
  }

  downloadDocument(details: CWDocCombined) {
    const filename = '';
    this.fileUploadService.downloadEmployeeFile(details, filename).subscribe(resp => {
      const extension = this.common.getFileExtension(details.fileName);
      saveAs(resp, `${this.getDocName(details)}${extension}`);
    },
      error => {
        Logger.error(error);
      });
  }


  uploadDoc() {
    if (this.ifDocNotValid) {
      this.toast.error(`Invalid file size. File size should be between
         ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      return;
    }
    if (isNullOrUndefined(this.selectedDocument)) {
      this.toast.warning("Please select a file!");
      return;
    }

    if (!this.fileDetails.isEditMode) {
      this.fileDetails.id = -1;
      this.fileDetails.createdById = this.authService.ActiveUser.employeeId;
    } else {
      this.fileDetails.modifiedById = this.authService.ActiveUser.employeeId;
    }
    this.uploadService();
  }

  get uploadedFiles(): Array<CWDocCombined> {
      return this.allFiles
  }

  uploadService() {
    this.loader.show();
    this.disableUpload = true;
      this.fileUploadService.postCWFile(this.fileDetails, this.cwProfile, this.selectedDocument).pipe(finalize(() => {
        this.disableUpload = false;
        this.loader.clear();
      }))
        .subscribe(resp => {
          this.uploadReponse(resp);
        }, error => {
          this.toast.error("Something went wrong!");
        });
    
    this.GetDocumentEvent.emit(this.allFiles);
  }
  


  uploadReponse(resp) {
    if (this.selectedDocument) {
      this.toast.success("File uploaded successfully!");
    } else {
      this.toast.success("Document details updated successfully!");
    }
    this.update.emit();
    this.getCWProfileDocuments();
  }

  get fileBrowserAllowedTypes() {
    return this.allowedMineTypes.join(',');
  }

  get ifDocNotValid(): boolean {
    if (this.selectedDocument && (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE)) {
      return true;
    }
    return false;
  }
  getDocNameForGrid(doc: CWDocCombined) {
    let docName = doc.documentName;
    return docName.replace("GPN_", '');
  }

  getDocName(details: CWDocCombined) {
    let firstName = this.cwProfile.firstName;
    let lastName = this.cwProfile.lastName;
    let docPrefix = (firstName !== null && lastName !== null) ? firstName +'_' + lastName : null;

    if (!docPrefix) {
      return details.documentName.replace("GPN_", '');
    }
    let docN = details.documentName && details.documentName.indexOf("GPN_") > -1 ?
      details.documentName.replace("GPN", `${docPrefix}`) : `${docPrefix}_${details.documentName}`
    return docN;
  }
  edit(fileDetails: CWDocCombined, i) {

    let index = this.allFiles.findIndex(file => file.id === fileDetails.id);
    this.allFiles[index].isEditMode = true;

    this.fileDetails.isEditMode = true;
    this.fileDetails.id = fileDetails.id;
    this.fileDetails.documentName = fileDetails.documentName;
    this.fileDetails.documentTypeId = fileDetails.documentTypeId;
    this.fileDetails.fileName = fileDetails.fileName;
    this.fileDetails.fileGuiId = fileDetails.fileGuiId;
    this.fileDetails.cwProfileId = fileDetails.cwProfileId;
    this.fileDetails.createdById = fileDetails.createdById;
    this.fileDetails.documentNameId = fileDetails.documentNameId;
    this.fileDetails.description = fileDetails.description;
    this.fileDetails.combainedId = fileDetails.documentNameId + '~' + fileDetails.documentName;
  }
  preview(details: EmployeeDoc) {

    this.openfilepreview.getFilePreviewToken(details).then(token => {
      this.tryOpenInNativeApp(token, details);
    }).catch(err => {
    });
  }

  tryOpenInNativeApp(token: string, details: EmployeeDoc) {
    const extension: string = details.fileName.split('.').pop();
    this.docName = `${details.documentName}.${extension}`;

    this.openfilepreview.previewFile(token, details.fileGuiId, this.docName).catch(r => {
      if (extension.toLowerCase() === 'pdf') {
        this.previewPDFFile(token, details);
      } else if (['png', 'jpg', 'jpeg'].indexOf(extension.toLowerCase()) > -1) {
        this.previewImageFile(token, details);
      }
    });
  }

  previewPDFFile(token: string, details: EmployeeDoc) {
    this.dialog.showPDFPreviewiew(this.openfilepreview.constructPDFUrl(token, this.docName), this.docName);
  }
  browseFile(fileDetails) {


    this.fileDetails.id = fileDetails.id;
    this.fileDetails.documentName = fileDetails.documentName;
    this.fileDetails.documentTypeId = fileDetails.documentTypeId;
    this.fileDetails.fileName = fileDetails.fileName;
    this.fileDetails.fileGuiId = fileDetails.fileGuiId;
    this.fileDetails.createdById = fileDetails.createdById;
    this.fileDetails.documentNameId = fileDetails.documentNameId;
    this.fileDetails.description = fileDetails.description ? fileDetails.description : '';
    this.fileDetails.combainedId = fileDetails.documentNameId + '~' + fileDetails.documentName;

    this.fileDetails.cwProfileId = this.cwProfile.id
    this.fileEle.nativeElement.click();

  }

  closeEdit(fileDetails: CWDocCombined) {
    let index = this.allFiles.findIndex(file => file.id === fileDetails.id);
    this.allFiles[index].isEditMode = false;
    this.fileDetails.isEditMode = false;
  }
  

  get selectedFileName(): string {
    return nullSafe(() => this.selectedDocument.name, '');
  }

  fileSelected(files: FileList) {
    if (!files.item(0)) {
      return;
    }
    this.selectedDocument = files.item(0);

    if (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE) {
      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      this.fileEle.nativeElement.value = null;
      return;
    }
    if (this.allowedMineTypes.indexOf(this.selectedDocument.type) < 0) {
      this.toast.error(`Invalid file type. Please select a valid file`);
      this.fileEle.nativeElement.value = null;
      this.selectedDocument = null;
      this.element.nativeElement.value = "";
      return;
    }
    this.fileDetails.fileName = this.selectedDocument.name;
    this.uploadDoc();
  }
  
  downloadAll() {
    if (this.showSpinner) {
      return;
    }
    if ((this.uploadedFiles.length <= 0
     )
      || isNullOrUndefined(this.cwProfile)
      || (this.cwProfile && this.cwProfile.id <= 0)) {
      this.toast.warning("No files to download!");
      return;
    }
    this.showSpinner = true;

    this.fileUploadService.downloadAllCWDocs(this.cwProfile.id).pipe(finalize(() => {
      this.showSpinner = false;
    })).subscribe(resp => {
      const fname = nullSafe(() => this.cwProfile.firstName, 'firstName');
      const lname = nullSafe(() => this.cwProfile.lastName, 'lastName');
      const filename = `${fname}_${lname}`;
      saveAs(resp, `${filename}.zip`);
    }, err => {
      Logger.error(err);
    });
  }

  setMandatory(id) {
    return false;
  }

  mandatoryCheck() {
    this.isMandatoryChecked = !this.isMandatoryChecked;
    this.getfileGrid(this.selectedTab);
  }

}
